import React from "react";

import { AccountType } from "component-library";
import { IBillingAddress } from "../services/online-application.types";
import { billingAddressInitialValues } from "../components/BillingAddressFormBlock";

export interface UserContextInfo {
  accountType: AccountType;
  locale: string;
  forenames: string;
  surname: string;
  email: string;
  address: IBillingAddress;
}

const DEFAULT_USER_CONTEXT = {
  accountType: AccountType.DefaultUser,
  locale: "en-GB",
  forenames: "",
  surname: "",
  email: "",
  address: billingAddressInitialValues,
};

interface UserContextParams extends UserContextInfo {
  ypDateOfBirth?: Date;
  ypMobileNumber?: string;
  isOrganisationMember?: boolean;
  isCDApplication?: boolean;
  updateUser: React.Dispatch<React.SetStateAction<UserContextInfo>>;
  clearUser: () => void;
}

export const UserContext = React.createContext<UserContextParams>({
  ...DEFAULT_USER_CONTEXT,
  ypDateOfBirth: undefined,
  ypMobileNumber: "",
  updateUser: () => {},
  clearUser: () => {},
});

interface UserContextProviderProps {
  children: React.ReactNode;
}

export const UserContextProvider = ({ children }: UserContextProviderProps) => {
  const [userInfo, setUserInfo] =
    React.useState<UserContextInfo>(DEFAULT_USER_CONTEXT);

  const clearUser = () => setUserInfo(DEFAULT_USER_CONTEXT);

  return (
    <UserContext.Provider
      value={{
        ...userInfo,
        updateUser: setUserInfo,
        clearUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => React.useContext(UserContext);
